
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Violin/index.md?watch=parent';
    export const demoIndex = {
  ids: ["violin-demo-common","violin-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__Violin" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Violin/index.md?type=demo')
};